(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (!data || data.source !== 'product-form') return;
    var btn = document.querySelector('product-info form[action*="/cart/add"] button[type="submit"]');
    if (!btn) return;
    btn.classList.add('florence-cta-success');
    window.setTimeout(function () {
      btn.classList.remove('florence-cta-success');
    }, 1400);
  });
})();
